import React, { createContext, useMemo } from 'react';
import { theme } from '../tokens/js/theme';
import { darkTheme } from '../tokens/js/darkTheme';
export const SUPPORTED_THEMES = ['light', 'dark'];
export const ThemeContext = createContext({
    selectedTheme: 'light',
});
export const ThemeProvider = ({ children, selectedTheme = 'light', ...rest }) => {
    let validTheme = selectedTheme;
    if (!SUPPORTED_THEMES.includes(selectedTheme)) {
        console.warn(`Unsupported theme passed to ThemeProvider: ${selectedTheme}, defaulting to light.`);
        validTheme = 'light';
    }
    const themedTextColor = useMemo(() => {
        switch (validTheme) {
            case 'dark':
                return darkTheme.color.white;
            case 'light':
            default:
                return theme.color.black;
        }
    }, [validTheme]);
    const themeContextValue = useMemo(() => ({
        selectedTheme: validTheme,
    }), [validTheme]);
    return (React.createElement(ThemeContext.Provider, { value: themeContextValue, ...rest },
        React.createElement("div", { style: { color: themedTextColor } }, children)));
};
ThemeProvider.displayName = 'ThemeProvider';
